export function isUnexpectedPnpmStoreError(error: unknown): boolean {
  return error instanceof Error && error.message.includes('ERR_PNPM_UNEXPECTED_STORE')
}
